import { useLayoutEffect, useRef, useState } from 'react';

// Measure the trailing link together with the copy so both fit within three
// lines at the current font size and container width, including after resizing.
export function ThreeLineDescription({ text }: { text: string }) {
  const container = useRef<HTMLDivElement>(null);
  const measure = useRef<HTMLParagraphElement>(null);
  const copy = useRef<HTMLSpanElement>(null);
  const link = useRef<HTMLButtonElement>(null);
  const [end, setEnd] = useState(text.length);
  const [expanded, setExpanded] = useState(false);
  useLayoutEffect(() => {
    const update = () => {
      if (!measure.current || !copy.current || !link.current) return;
      const maxHeight = parseFloat(getComputedStyle(measure.current).lineHeight) * 3 + 1;
      link.current.style.display = 'none';
      copy.current.textContent = text;
      if (measure.current.getBoundingClientRect().height <= maxHeight) { setEnd(text.length); return; }
      link.current.style.display = 'inline';
      let low = 0, high = text.length;
      while (low < high) {
        const middle = Math.ceil((low + high) / 2);
        copy.current.textContent = text.slice(0, middle).trimEnd() + '… ';
        if (measure.current.getBoundingClientRect().height <= maxHeight) low = middle;
        else high = middle - 1;
      }
      const word = text.lastIndexOf(' ', low);
      setEnd(word > 0 ? word : low);
    };
    update();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
    if (container.current) observer?.observe(container.current);
    document.fonts?.ready.then(update);
    return () => observer?.disconnect();
  }, [text]);
  const truncated = end < text.length;
  return <div ref={container} className="preview-description">
    <p>{expanded || !truncated ? text : text.slice(0, end).trimEnd() + '… '}{truncated && <button className="preview-read-more" aria-expanded={expanded} onClick={() => setExpanded(value => !value)}>{expanded ? ' Show less' : 'Read more'}</button>}</p>
    <p className="preview-description-measure" ref={measure} aria-hidden="true"><span ref={copy} /><button ref={link} tabIndex={-1} className="preview-read-more">Read more</button></p>
  </div>;
}
